class Logger {
  private startTime: number;
  private readonly prefix: string;
  private readonly color: string;
  
  constructor(prefix = 'LOG', color = '#00ca38') {
    this.prefix = prefix;
    this.color = color;
    this.startTime = new Date().getTime();
  }
  
  public log(txt: string, ...args: unknown[]): void {
    if (!localStorage.getItem('_QON_debugSearch')) {
      return;
    }
    
    const elapsed = ((new Date().getTime() - this.startTime) / 1000).toFixed(3) + 's |';
    const postfix = this.prefix + '|';
    
    let logArgs: unknown[] = [];
    logArgs = [`%c${elapsed}${postfix} ${txt}`, `color: ${this.color}`, ...args];
    
    console.log(...logArgs);
  }
}


// Przykład użycia:
export const searchLogger = new Logger('SSv3 LOG');
// searchLogger.log('This is a search log.');

export const searchErrorLogger = new Logger('SSv3 ERROR', '#ff0000');
// errorLogger.log('This is an error log.');

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.enableSearchDebugMode = () => {
  localStorage.setItem('_QON_debugSearch', 'true')
  location.reload()
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.disableSearchDebugMode = () => {
  localStorage.removeItem('_QON_debugSearch')
  location.reload()
}


